import { useEffect, useState } from 'react';
import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';
import cookies from '@buzzfeed/bf-utils/lib/cookies';
import { queryStringToObject } from '@buzzfeed/bf-utils/lib/query-string';
import { setCookie } from '../../utils/affiliate';

/**
 * Initialize trackonomics tracking
 * Only loads on US shopping pages that are not in link editor excluded categories
 */

export default function useTrackonomics(uniquePageValue) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) {
      return;
    }
    // set bf-origin cookie for trackonomics - only include origin from qs
    const qsObj = queryStringToObject(window.location.search);
    if (
      qsObj &&
      'origin' in qsObj &&
      qsObj['origin'].length &&
      cookies.get('bf-origin') !== qsObj['origin']
    ) {
      setCookie('bf-origin', qsObj['origin']);
    }

    const loadTrackonomics = async () => {
      setInitialized(true);

      // initialize trackonomics script with appropriate attributes here
      const script = await loadScript(
        'https://cdn-magiclinks.trackonomics.net/client/static/v2/buzzfeed_ok567kgt88.js'
      );

      if (script) {
        // setting required funnel relay attributes
        script.setAttribute('id', 'funnel-relay-installer');
        script.setAttribute('data-property-id', 'PROPERTY_ID');
        script.setAttribute('data-customer-id', 'buzzfeed_ok567kgt88');
      }
    };

    loadTrackonomics();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniquePageValue, initialized]);
}
